<style  scoped>

.section__sectors__FixedHeight900
{
    height: 900px;
}

.u-bg--white__Sectors__ValueAdded
{
    background-color: #f2f2f2;
}

.u-bg--white__Sectors__Cybersecurity
{
    background-color: #f2f2f2;
}
</style>
<template>
<div class="c-page u-relative">
<section data-color="clear" class="u-relative u-fit-w u-bg--brand-dark u-overflow-h js-header-panel">
  <div class="c-page__header o-wrapper--panel" :style="'transform:translateX(' + headerPageSize[2] + 'px) translateY('+headerPageSize[3]+'px) scale('+headerPageSize[4]+')'" >
                <img :src="globalContent.nav.links[3].image.src" class="u-absolute u-pos-tl" :style="'width:' + headerPageSize[0] + 'px; height:'+headerPageSize[1]+'px' ">
    </div>
    <div class="o-wrapper--valign u-viewport-fit-h u-fit-w">
             <div class="u-relative u-inline-block c-top-maintitle u-pos-x-center u-align-center">
               <span class="c-page__subtitle t-hh1 t-text-ls--md t-text--roman u-color--white u-align-center  u-inline-block " v-html="content.subtitle"></span>
                 <h1 class="t-h2-sub  t-text-lh--md u-color--white u-align-center  u-marg-b-lg">
                     <app-sliced-text :content="content.title"></app-sliced-text>
                 </h1>
               </div>
         </div>
         <button v-scroll-to="'#start'" class="c-home__scroll-btn c-btn-scroll  u-pos-x-center t-btn u-absolute u-inline-block  u-marg-b-md@sm">
          <img src="/static/common/MainLogoWhite -arrow-white2.svg"  width="32px" >
          </button>

</section>

    <section  :data-color="item.dataColor" v-for="(item, index)  in content.blocks" class="u-relative u-overflow-h u-fit-w  u-pad-x-w2of12 u-pad-x-w1of12@md  u-pad-x-w1of12@sm   js-header-panel" :class="[item.bgColorClass]" >
     <a id="start">
     <span v-if="index<content.blocks.length -1" class="c-line c-line--x u-absolute u-pos-bl u-bg--gray u-fit-w"></span>
          <div class="c-investors__section u-relative u-flex u-pad-yb0-lg@sm u-flex-fd--column@sm u-pad-t-xxl u-pad-b-xxl u-pad-b-xxl@sm u-zindex--2" v-if="item.special==='special-left'">
            <div  v-if="index===0"    class="u-absolute u-pos-tl u-fit">
                  <div class="c-investors__section-2__pattern u-absolute u-pos-br u-w2of5 u-marg-b-0@sm u-opacity--20@sm u-w3of4@sm">
                       <img src="/static/Charcuterie/QatarIntegratedRailway-99.jpg" class="u-fit-w" >
                     </div>
             </div>
             <div v-if="index===2"    class="u-absolute u-pos-tl u-fit">
                   <div class="c-investors__section-2__pattern u-absolute u-pos-br u-w2of5 u-marg-b-0@sm u-opacity--20@sm u-w3of4@sm">
                        <img src="/static/Charcuterie/Charcuterie-closer.jpg" class="u-fit-w" >
                      </div>
              </div>
              <div v-if="index===4"    class="u-absolute u-pos-tl u-fit">
                    <div class="c-investors__section-2__pattern u-absolute u-pos-br u-w2of5 u-marg-b-0@sm u-opacity--20@sm u-w3of4@sm">
                         <img src="/static/Charcuterie/Charcuterie-closer.jpg" class="u-fit-w" >
                       </div>
               </div>
            <div class="u-marg-b-xxl u-marg-b-lg@sm u-w5of8 u-w3of4@md u-marg-l-w1of12@sm u-pad-l-0@lg u-fit-w@sm" :class="{'u-pad-l-w1of8':item.padLeft==='1'}">
                <div>
                  <app-scroll-object :offset=".05" :isParallax="!1" inline-template :content="item">
                        <h3 class="t-h3 t-text--roman u-relative u-marg-r-lg   u-marg-r-0@sm" :class="{'careers-u-color--brand':item.color==='dark','u-color--white':item.color==='white'}">
                            <app-words  :isActive="isActive" :delay="0" :content="content.title"></app-words>
                          </h3>
                    </app-scroll-object>
                </div>
                <div :key="indexin" v-for="(itemin, indexin)  in item.content">
                    <h6 class=" t-text--md u-pad-t-lg" v-if="'title'===itemin.type.value" :class="{'t-text--md--bold':itemin.bold==='true','careers-u-color--brand':itemin.color==='dark','u-color--white':itemin.color==='white','u-color--gray':itemin.color==='gray'}">
                        <app-scroll-object   :offset=".05"  :isParallax="!1" inline-template  :content="itemin" >
                             <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                         </app-scroll-object >
                      </h6>
                    <div class="u-marg-t-md t-text--md" v-if=" 'default'===itemin.type.value" :class="{'u-marg-t-md':indexin>0,'u-color--gray':itemin.color==='dark','u-color--white':itemin.color==='white'}" v-html="itemin.content"> </div>
                  </div>
            </div>
        </div>
        <div class="c-investors__section u-relative u-flex u-flex-fd--column@sm  u-pad-t-xxl u-pad-b-xxl u-pad-b-xxl@sm u-pad-t-xs@sm" v-if="item.special==='special-right'">
          <div  v-if="index===0" class="u-absolute u-pos-tl u-fit">
                  <div class="c-investors__section-2__pattern u-absolute siscomp u-w2of2@sm u-w2of5 u-marg-b-0@sm u-opacity--47@sm u-w3of4@sm">
                     <img src="/static/Charcuterie/Charcuterie-Expert.jpg" class="u-fit-w" >
                   </div>
           </div>
           <div v-if="index===2" class="u-absolute u-pos-tl u-fit">
                   <div class="c-investors__section-2__pattern u-absolute siscomp u-w2of5 u-w2of2@sm u-marg-b-0@sm u-opacity--47@sm u-w3of4@sm">
                      <img src="/static/Charcuterie/Charcuterie-closer.jpg" class="u-fit-w" >
                    </div>
            </div>
            <div v-if="index===4" class="u-absolute u-pos-tl u-fit">
                  <div class="c-investors__section-2__pattern u-absolute siscomp u-w2of5 u-w2of2@sm u-marg-b-0@sm u-opacity--47@sm u-w3of4@sm">
                       <img src="/static/Charcuterie/Charcuterie-closer.jpg" class="u-fit-w" >
                     </div>
             </div>
          <div  v-if="index===1" class="u-absolute u-pos-tl u-fit">
            <div class="c-investors__section-2__pattern u-absolute siscomp u-w2of5 u-w2of2@sm u-marg-b-0@sm u-opacity--47@sm u-w3of4@sm">
                   <img src="/static/Charcuterie/Charcuterie.jpg" class="u-fit-w" >
                 </div>
           </div>
           <div v-if="index===3"    class="u-absolute u-pos-tl u-fit">
             <div class="c-investors__section-2__pattern u-absolute siscomp u-w2of5 u-w2of2@sm u-marg-b-0@sm u-opacity--47@sm u-w3of4@sm">
                    <img src="/static/Charcuterie/fromagerie.jpg" class="u-fit-w" >
                  </div>
            </div>
            <div v-if="index===5"    class="u-absolute u-pos-tl u-fit">
              <div class="c-investors__section-2__pattern u-absolute siscomp u-w2of5 u-w2of2@sm u-marg-b-0@sm u-opacity--47@sm u-w3of4@sm">
                     <img src="/static/Charcuterie/QatarIntegratedRailway-104.jpg" class="u-fit-w" >
                   </div>
             </div>
              <div v-if="index===6"    class="u-absolute u-pos-tl u-fit">
              <div class="c-investors__section-2__pattern u-absolute siscomp u-w2of5 u-w2of2@sm u-marg-b-0@sm u-opacity--47@sm u-w3of4@sm">
                     <img src="/static/Charcuterie/QatarIntegratedRailway-110.jpg" class="u-fit-w" >
                   </div>
             </div>
             <div v-if="index===7"    class="u-absolute u-pos-tl u-fit">
              <div class="c-investors__section-2__pattern u-absolute siscomp u-w2of5 u-w2of2@sm u-marg-b-0@sm u-opacity--47@sm u-w3of4@sm">
                     <img src="/static/Charcuterie/QatarIntegratedRailway-106.jpg" class="u-fit-w" >
                   </div>
             </div>
             <div v-if="index===8"    class="u-absolute u-pos-tl u-fit">
              <div class="c-investors__section-2__pattern u-absolute siscomp u-w2of5 u-w2of2@sm u-marg-b-0@sm u-opacity--47@sm u-w3of4@sm">
                     <img src="/static/Charcuterie/QatarIntegratedRailway-107.jpg" class="u-fit-w" >
                   </div>
             </div>
             <div v-if="index===8"    class="u-absolute u-pos-tl u-fit">
              <div class="c-investors__section-2__pattern u-absolute siscomp u-w2of5 u-w2of2@sm u-marg-b-0@sm u-opacity--47@sm u-w3of4@sm">
                     <img src="/static/Charcuterie/QatarIntegratedRailway-108.jpg" class="u-fit-w" >
                   </div>
             </div>
             <div v-if="index===9"    class="u-absolute u-pos-tl u-fit">
              <div class="c-investors__section-2__pattern u-absolute siscomp u-w2of5 u-w2of2@sm u-marg-b-0@sm u-opacity--47@sm u-w3of4@sm">
                     <img src="/static/Charcuterie/QatarIntegratedRailway-109.jpg" class="u-fit-w" >
                   </div>
             </div>
            
            <div class="u-w3of8 u-w1of2@md u-fit-w@sm">
                <h3 class="t-h3 t-text--roman u-relative u-marg-r-lg u-marg-r-0@sm"> </h3>
            </div>
            <div class="u-marg-t-lg@sm u-marg-b-xxl@sm u-marg-b-xxl@smx u-pad-l-0@sm  u-marg-b-md u-w5of8 u-w2of2@sm u-w3of4@md u-pad-l-w1of8 u-pad-l-0@md u-fit-w@sm">
                <div>
                    <app-scroll-object :offset=".05" :isParallax="!1" inline-template :content="item">
                        <h3 class="t-h3 t-text--roman u-relative u-marg-r-lg  u-pad-b-md u-marg-r-0@sm" :class="{'careers-u-color--brand':item.color==='dark','u-color--white':item.color==='white'}">
                            <app-words  :isActive="isActive" :delay="0" :content="content.title"></app-words>
                          </h3>
                    </app-scroll-object>
                </div>
                <div :key="indexin" v-for="(itemin, indexin)  in item.content">
                    <h6 class="t-text--ultra t-text-lh--md t-text--roman" v-if="'title'===itemin.type.value" :class="{'u-marg-t-lg':indexin>0,'careers-u-color--brand':itemin.color==='dark','u-color--white':itemin.color==='white','u-color--gray':itemin.color==='gray'}">
                        <app-scroll-object   :offset=".05"  :isParallax="!1" inline-template  :content="itemin" >
                             <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                         </app-scroll-object >
                      </h6>
                    <div class="u-marg-t-md t-text--ultra" v-if=" 'default'===itemin.type.value" :class="{'u-marg-t-md':indexin>0,'u-color--gray':itemin.color==='dark','u-color--white':itemin.color==='white'}" v-html="itemin.content"> </div>
                    <div v-if=" 'blockquote'===itemin.type.value">
                        <app-scroll-object :offset="0" :isParallax="!1" inline-template :content="itemin">
                            <p class="c-investors__section-1__blockquote u-relative u-marg-t-lg u-pad-t-lg t-text--ultra t-text-lh--md t-text--roman-italic u-color--brand-blue">
                                <span class="c-line--x u-absolute u-pos-tl u-fit-w u-bg--brand-blue"></span>
                                <app-words :isActive="isActive" :delay="0" :content="content.content"></app-words>
                            </p>
                        </app-scroll-object>
                    </div>
                </div>
            </div>
        </div>
        </a>
    </section>
    <app-footer :globalContent="globalContent" :adminContent="adminContent"></app-footer>
</div>

</template>

<script>

import AppFooter from '../app-footer/index.vue'
import AppScrollObject from '../app-scroll-object/index.vue'
import AppSlicedText from '../app-sliced-text/index.vue'
import AppRiskTools from '../app-sliced-text/index.vue'
export default {
    props: {
      debug: {
          type: Boolean,
          default: !1
      },
        adminContent: {
            type: Object,
            default: function() {}
        },
        globalContent: {
            type: Object,
            default: function() {}
        },
        headerPageSize: {
            type: Array,
            default: function() {}
        }
    },
    components: {
        "app-footer": AppFooter,
        "app-scroll-object": AppScrollObject,
        "app-sliced-text": AppSlicedText,
        "app-risk-tools": AppRiskTools
    },
    computed: {
        content: function() {
            return this.adminContent.en.pages.services
        },
        myStylesTransform2() {
            return {
                transform: 'translateX(' + this.headerPageSize[2] + 'px) translateY(' + this.headerPageSize[3] + 'px) scale(' + this.headerPageSize[4] + ')'

            }

        },
        myStylesWidthHeight() {
            return {
                width: this.headerPageSize[0] + "px",
                height: this.headerPageSize[1]/2 + "px"
                //height: 400 + "px"

            }
        },
        myStylesWidthHeight11() {
            return {
                width: "1600px",
                height: "900px"

            }
        }
    },
    created: function() {
        this.eventHub.$on("resize", this.onResize)
    },
    destroyed: function() {
        this.eventHub.$off("resize", this.onResize)
    },
    mounted: function() {
         setTimeout(function() {this.isTitleVisible = !0}, 2e3),
         this.onResize(),
          this.eventHub.$emit("page:ready")
    },
    data: function() {
        return {
            isTitleVisible: !1
          //  imageHeadSrc: require('../../assets/medias/images/services/stock-7-1.jpg')

        }
    },
    methods: {
        onResize: function() {}
    }

}

</script>
